/** Horas acumulam acima de 24h: uma oferta de 2 dias vira 48:00:00. */
export default function tempoRestante(
  fim?: string | null,
  agora: number = Date.now(),
): string | null {
  if (!fim) return null;
  const ms = new Date(fim).getTime() - agora;
  if (Number.isNaN(ms) || ms <= 0) return '00:00:00';
  const total = Math.floor(ms / 1000);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  return [h, m, s].map(n => String(n).padStart(2, '0')).join(':');
}
